export default {
	mounted(el, binding) {
		applySoftDisabled(el, binding.value)
	},
	updated(el, binding) {
		applySoftDisabled(el, binding.value)
	},
}

function applySoftDisabled(el, isDisabled) {
	if (isDisabled) {
		el.style.opacity = '0.5'
		el.style.pointerEvents = 'auto'
		el.style.cursor = 'not-allowed'
		el.style.color = 'rgba(0, 0, 0, 0.26)'
	} else {
		el.style.opacity = ''
		el.style.pointerEvents = ''
		el.style.cursor = ''
		el.style.color = ''
	}
}
